import React, { FC } from 'react';

import { A, Article, CONTACT_URL, Document, Heading, Ol, P, Ul } from './Layout';

const Privacy: FC = () => (
  <Document
    title="プライバシーポリシー"
    enactedOn="2026年9月11日"
    lead="チェック運営（以下「運営者」といいます。）は、運営者が提供するアプリケーション「CHECK」（以下「本アプリ」といいます。）における、個人情報を含む利用者情報の取扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます。）を定めます。"
  >
    <Article title="1. 取得する情報">
      <Heading>(1) ユーザーにご登録いただく情報</Heading>
      <Ul
        items={[
          'Appleアカウントによるサインインに伴いAppleから提供される識別子およびメールアドレス。Appleの「メールを非公開」を選択された場合は、Appleが発行する転送用のメールアドレスを取得します。',
          'プロフィール：名前、プロフィール写真、性別、生まれ年',
          'ペアに関する情報：ペアコード、ふたりの記念日',
          'アイディア：本文、絵文字、メモ、URL、叶えた日時',
          '写真：アイディアに紐づけて撮影または選択された画像、当該画像をもとに生成されるチェキ、写真に添えるひとこと',
          '通知に関する設定',
        ]}
      />

      <Heading>(2) 本アプリの利用に伴い自動的に取得する情報</Heading>
      <Ul
        items={[
          'プッシュ通知を届けるための端末の識別子、端末のOSの種別',
          'アプリのバージョン、操作の履歴、エラーの記録',
          'IPアドレス、アクセス日時',
        ]}
      />

      <Heading>(3) 課金に関する情報</Heading>
      <P>
        App Storeを通じたご購入について、購読しているプラン、有効期限および更新状態を取得します。クレジットカード番号その他の決済情報は、AppleおよびAppleの決済事業者が取り扱うものであり、運営者がこれを取得することはありません。
      </P>
    </Article>

    <Article title="2. 利用目的">
      <P>運営者は、取得した利用者情報を次の目的で利用します。</P>
      <Ul
        items={[
          '本アプリの提供、本人確認、ペアの成立および維持のため',
          'アイディア、写真およびチェキを保存し、ペアの双方に表示するため',
          'チェキの作成、およびプッシュ通知の配信のため',
          '有料プランの提供、課金状況の確認および上限の判定のため',
          'お問い合わせへの対応、および重要なお知らせの連絡のため',
          '不正利用、規約違反および障害の調査、ならびにこれらへの対応のため',
          '個人を識別できない形に加工した統計データを作成し、本アプリの改善に役立てるため',
        ]}
      />
      <P>
        なお、性別および生まれ年は、本アプリの利用状況の把握および改善のために取得するものであり、ペアの相手方を含む他のユーザーに表示されることはありません。
      </P>
    </Article>

    <Article title="3. ペアの相手方への共有">
      <P>
        本アプリは、ふたりでひとつのリストを共有するものです。ペアを組んだ相手方には、次の情報が表示されます。
      </P>
      <Ul
        items={[
          'あなたの名前およびプロフィール写真',
          'あなたが登録したアイディア（本文、絵文字、メモ、URL）。相手方はこれを編集または削除することができます。',
          'あなたが撮影した写真、チェキおよびひとこと',
          'ふたりの記念日、アイディアを叶えた記録',
        ]}
      />
      <P>
        ユーザーは、相手方に見せてよい情報のみを登録してください。ペアを解除すると、解除前のアイディアおよびチェキは双方から閲覧できなくなります。
      </P>
    </Article>

    <Article title="4. 第三者提供">
      <P>
        運営者は、次の場合を除き、あらかじめユーザーの同意を得ることなく、利用者情報を第三者に提供しません。
      </P>
      <Ul
        items={[
          '法令に基づく場合',
          '人の生命、身体または財産の保護のために必要がある場合であって、ユーザーの同意を得ることが困難であるとき',
          '国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに協力する必要がある場合であって、ユーザーの同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき',
          '合併その他の事由による事業の承継に伴って提供される場合',
          '利用目的の達成に必要な範囲内で、利用者情報の取扱いの全部または一部を委託する場合',
        ]}
      />
    </Article>

    <Article title="5. 業務の委託と国外への移転">
      <P>
        運営者は、本アプリの提供にあたり、認証、データの保管、通知の配信、課金状況の管理といった業務の一部を外部の事業者に委託しています。委託先に対しては、利用目的の達成に必要な範囲に限って利用者情報を取り扱わせるとともに、必要かつ適切な監督を行います。
      </P>
      <P>
        これらの委託先の設備は日本国外（主にアメリカ合衆国）に所在する場合があり、その場合、利用者情報は当該国に移転されます。委託先の名称および所在する国については、
        <A href={CONTACT_URL}>お問い合わせフォーム</A>
        より請求があった場合に遅滞なくお知らせします。
      </P>
      <P>
        本アプリは、広告の配信および広告目的の行動追跡を行っておらず、広告事業者に利用者情報を提供することはありません。
      </P>
    </Article>

    <Article title="6. 保存期間と削除">
      <Ol
        items={[
          'アイディアを削除すると、当該アイディアに紐づく写真およびチェキもあわせて削除され、元に戻すことはできません。',
          '退会すると、アカウント、および当該ユーザーが登録したアイディア・写真・チェキはすべて削除されます。ペアの相手方が本アプリを継続して利用している場合であっても、退会したユーザーが登録したアイディアは、そこに相手方が追加した写真とともに削除されます。',
          '退会は、本アプリの設定画面から行うことができます。退会してもApp Storeのサブスクリプションは自動では停止しないため、Premiumをご利用の場合はiOSの「設定」内のサブスクリプションの管理画面から別途解約してください。',
          '運営者は、法令に基づき保存が必要な情報、および障害の調査のための記録を、必要な期間に限り保存することがあります。',
        ]}
      />
    </Article>

    <Article title="7. 端末の権限">
      <P>
        本アプリは、写真を撮る、端末内の写真を選ぶ、チェキを端末に保存する、通知を受け取るといった機能のために、カメラ、写真ライブラリおよび通知の権限を利用します。これらの権限は、iOSの「設定」からいつでも変更できます。権限を許可しない場合、対応する機能をご利用いただけないことがあります。
      </P>
    </Article>

    <Article title="8. 安全管理措置">
      <P>
        運営者は、利用者情報の漏えい、滅失または毀損の防止その他の安全管理のために、通信の暗号化、取り扱う者の限定その他の必要かつ適切な措置を講じます。写真は、ペアの当事者以外が参照できないよう保護したうえで配信されます。
      </P>
    </Article>

    <Article title="9. 開示、訂正、利用停止等">
      <P>
        運営者は、ユーザーご本人から、個人情報の保護に関する法律の定めに基づき、保有個人データの開示、訂正、追加、削除、利用停止または第三者提供の停止を求められた場合には、ご本人からのご請求であることを確認のうえ、遅滞なく対応します。ご請求は、
        <A href={CONTACT_URL}>お問い合わせフォーム</A>
        よりお願いいたします。なお、法令により運営者がこれらの義務を負わない場合は、この限りではありません。
      </P>
    </Article>

    <Article title="10. 13歳未満の方について">
      <P>
        本アプリは13歳未満の方を対象としておらず、13歳未満の方の情報を意図的に取得することはありません。13歳未満の方の情報を取得していることが判明した場合、運営者は速やかに当該情報を削除します。
      </P>
    </Article>

    <Article title="11. 本ポリシーの変更">
      <P>
        運営者は、必要に応じて本ポリシーを変更します。法令上ユーザーの同意が必要となる変更を行う場合、変更後の本ポリシーは、運営者所定の方法で変更に同意したユーザーに対してのみ適用されるものとします。運営者は、本ポリシーを変更する場合には、変更後の本ポリシーの効力発生時期および内容を、本アプリ上での表示その他の適切な方法により周知し、またはユーザーに通知します。
      </P>
    </Article>

    <Article title="12. お問い合わせ窓口">
      <P>
        利用者情報の取扱いに関するご意見、ご質問は、
        <A href={CONTACT_URL}>お問い合わせフォーム</A>
        よりお願いいたします。事業者の名称および所在地は、請求があった場合に遅滞なくお知らせします。
      </P>
    </Article>
  </Document>
);

export default Privacy;
